import useId from "@/shared/hooks/useId";
import useRestaurantTableUpdate from "@/shared/mutations/restaurantMap/useRestaurantTableUpdate";
import { asArray } from "@/shared/utils/helpers";
import { RestaurantTable } from "@/shared/utils/interfaces";
import { Stage as StageRef } from "konva/lib/Stage";
import { useCallback, useEffect, useRef } from "react";
import { Layer, Stage } from "react-konva";
import Table from "./Table";
import { useSetTable } from "./useTable";
import useTablesMapHook from "./useTablesMapHook";
export const TablesContainer = ({ backgroundColor, ...props }) => (
  <Stage
    style={{
      backgroundColor: backgroundColor || "#d79b83",
      borderRadius: "0.4rem",
      border: "1px solid var(--grey-blue-light)",
    }}
    {...props}
  />
);

export interface TablesMapProps {
  tables: RestaurantTable[];
  readOnly?: boolean;
  highLight?: number;
  height?: any;
  width?: any;
  scaleY?: number;
  scaleX?: number;
  onTableClick?: (tables: RestaurantTable) => void;
  unavailableTables?: number[];
  customSelectedTable?: number[];
  background_color?: string;
}
const TablesMap = ({
  customSelectedTable = undefined,
  highLight = undefined,
  readOnly = false,
  tables = [],
  height = window.innerHeight - 100,
  width = 1000,
  onTableClick,
  unavailableTables = [],
  background_color = "#d79b83",
}: TablesMapProps) => {
  const stageRef = useRef<StageRef>(null);
  const setSelectedTable = useSetTable();
  const { checkDeselect } = useTablesMapHook(stageRef.current);
  const mapId = useId();
  const update = useRestaurantTableUpdate(mapId);

  const baseWidth = 1000; // "ontwerpbreedte"
  const baseHeight = 1000; // "ontwerphoogte"

  // bereken schaalfactor
  const scaleX = width / baseWidth;
  const scaleY = height / baseHeight;
  const scale = Math.min(scaleX, scaleY); // behoud aspect ratio

  const onDrag = useCallback(
    (table: RestaurantTable) => {
      update.mutate(table);
    },
    [tables],
  );

  useEffect(() => {
    if (highLight) {
      setSelectedTable(asArray(tables)?.find((t) => t.item_id === highLight));
    }
  }, [highLight, tables]);

  return (
    <TablesContainer
      backgroundColor={background_color}
      ref={stageRef}
      width={width}
      height={height}
      onMouseDown={checkDeselect}
      onTouchStart={checkDeselect}
    >
      <Layer scaleX={scale} scaleY={scale}>
        {tables?.map((table, i) => (
          <Table
            customSelectedTable={customSelectedTable}
            hasSession={unavailableTables.includes(table.item_id)}
            readOnly={readOnly}
            key={i}
            {...table}
            onTableClick={onTableClick}
            onChange={onDrag}
          />
        ))}
      </Layer>
    </TablesContainer>
  );
};

export default TablesMap;
